(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function() {
    function initDescToggle() {
      var details = document.querySelector('.product-details');
      if (!details) return;

      // Find the description: look for rte-formatter elements that contain paragraphs with real text (not price, not title)
      var rteElements = details.querySelectorAll('rte-formatter.rte, .rte');
      var descEl = null;

      rteElements.forEach(function(el) {
        // Skip if it contains a price element
        if (el.querySelector('.price, product-price, [data-testid*="price"]')) return;
        // Skip if it's the product title element (but allow headings inside description content)
        if (el.querySelector('[data-testid*="product-title"], .product__title')) return;
        // Check if it has paragraph text longer than 30 chars
        var paragraphs = el.querySelectorAll('p');
        var hasRealText = false;
        paragraphs.forEach(function(p) {
          if (p.textContent.trim().length > 30) hasRealText = true;
        });
        if (hasRealText && !descEl) descEl = el;
      });

      if (!descEl) return;

      // Check if already wrapped
      if (descEl.parentElement && descEl.parentElement.classList.contains('aura-desc-toggle')) return;

      // Wrap the description in a toggle container
      var wrapper = document.createElement('div');
      wrapper.className = 'aura-desc-toggle';
      descEl.parentNode.insertBefore(wrapper, descEl);
      wrapper.appendChild(descEl);

      // Create toggle button
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'aura-desc-btn';
      btn.innerHTML = '<span class="aura-desc-label">Show more</span><span class="aura-desc-icon">&#9662;</span>';
      wrapper.parentNode.insertBefore(btn, wrapper.nextSibling);

      btn.addEventListener('click', function() {
        var expanded = wrapper.classList.toggle('aura-desc--expanded');
        btn.classList.toggle('aura-desc--expanded', expanded);
        var label = btn.querySelector('.aura-desc-label');
        if (label) {
          label.textContent = expanded ? 'Show less' : 'Show more';
        }
      });
    }

    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDescToggle);
    } else {
      initDescToggle();
    }

    // Re-run when section reloads (Shopify theme editor)
    document.addEventListener('shopify:section:load', initDescToggle);
  })();

  } catch(e) { console.error(e); }
})();
})();
